import { TagsList } from '../TagsList';
import { fromCamelCaseToWords } from '../../misc/functions';
import { NO_DATA } from '../../misc/misc.constants';
import type { Website } from '../../types';

interface TagsCellProps {
  column: string;
  websiteData: Website;
}

export function TagsCell({ column, websiteData }: TagsCellProps) {
  return (
    <td data-title={fromCamelCaseToWords(column)} data-qa={column}>
      {websiteData.tags.length ? (
        <TagsList items={websiteData.tags} />
      ) : (
        NO_DATA
      )}
    </td>
  );
}
